import { Redirect } from "expo-router";

export default function AlarmSettingsScreen() {
  return <Redirect href="/overview" />;
}
